import {
    APP,
} from '_pixiSrc/globals';
import * as easing from '_pixiSrc/animation/easing';
import Tween from '_pixiSrc/animation/Tween';

import GameData from './GameData';

let CURRENT_MUSIC = '';
let CURRENT_MUSIC_CHANNEL = '';
let counterPlayingSounds = 0;
let musicTween = null;

const musicVolume = 0.25;

/**
 * @class AudioManager
 * AudioManager class manage sounds
 */
class AudioManager {
    /**
   * @name playMusic
   * @param name
   * @param channel
   * @param looped
   * @description start playing music
   */
    static playMusic(name = 'reel_spin_slower', channel = 'music', looped = true) {
        if (!GameData.getProperty('musicEnabled')) { return; }

        if (CURRENT_MUSIC == name) {
            this.resumeMusic();
            return;
        }

        CURRENT_MUSIC = name;
        CURRENT_MUSIC_CHANNEL = channel;
        APP.audio.getChannel(channel).play(name, looped);
        APP.audio.getChannel(channel).volume = musicVolume;
    }

    /**
   * @name stopMusic
   * @param time
   * @description stop music
   */
    static stopMusic(time = 0) {
        this.muteMusic(time, () => {
            if (CURRENT_MUSIC_CHANNEL) { APP.audio.getChannel(CURRENT_MUSIC_CHANNEL).stop(); }
            CURRENT_MUSIC = null;
            CURRENT_MUSIC_CHANNEL = null;
        });
    }

    /**
   * @name playCoinsSound
   * @param duration
   * @description play coins sound
   */
    static playCoinsSound(duration = 500) {
        if (!GameData.getProperty('soundEnabled')) { return; }

        APP.audio.getChannel('fxCoins').play('reels_win_counter_1s', true);
        setTimeout(() => this.stopCoinsSound(), duration);
    }

    /**
   * @name stopCoinsSound
   * @description stop coins sound
   */
    static stopCoinsSound() {
        APP.audio.getChannel('fxCoins').stop();
    }

    static playSound(channel = 'fx', name, callback = () => { }) {
        if (!GameData.getProperty('soundEnabled')) { return; }

        channel = APP.audio.getChannel(channel).play(name);
        channel.once('end', callback);

        return channel;
    }

    /**
   * @name stopAllSounds
   * @description stop all sound
   */
    static stopAllSounds() {
        APP.audio.getChannel('fx').stop(); // add all the audio channels from the config
        APP.audio.getChannel('fxCoins').stop();
        counterPlayingSounds = 0;
    }

    /**
   * @name muteMusic
   * @description mute music
   */
    static muteMusic(time = 500, callback) {
        if (!GameData.getProperty('musicEnabled')) { return; }
        if (CURRENT_MUSIC) { this._increaseMusicTo(0.1, time, callback); } else if (callback) { callback(); }
    }

    static muteMusicOnDisabled() {
        if (CURRENT_MUSIC) {
            this._increaseMusicTo(0.001, 0);
        }
    }

    /**
   * @name resumeMusic
   * @description resume music
   */
    static resumeMusic(time = 200) {
        if (!GameData.getProperty('musicEnabled')) { return; }

        if (CURRENT_MUSIC) { this._increaseMusicTo(musicVolume, time); }
    }

    /**
   * @name _increaseMusicTo
   * @param finish
   * @param duration
   * @param callback
   * @description increase music
   */
    static _increaseMusicTo(finish, duration, callback) {
        if (musicTween) {
            musicTween.finish();
        }

        if (CURRENT_MUSIC_CHANNEL) {
            const chanel = APP.audio.getChannel(CURRENT_MUSIC_CHANNEL);
            const start = chanel.volume;
            const obj = {
                value: 0,
            };

            musicTween = new Tween(obj, 'value', start, finish, duration, easing.linear.easeInOut).play();

            musicTween.on('change', (e) => {
                chanel.volume = e.value;
            });

            musicTween.on('finish', () => {
                chanel.volume = finish;
                if (callback) { callback(); }
            });
        } else if (callback) { callback(); }
    }
}

export default AudioManager;
